import { createContext, type ReactNode, useContext, useState } from "react";
import { createSinglePlayer, type SinglePlayer } from "./single-player";

/**
 * The app-wide default: without a provider every `Media` shares this one, so
 * the rule holds with nothing mounted. A provider scopes a separate one — a
 * story, or a surface that must not pause the screen beneath it.
 */
const SinglePlayerContext = createContext<SinglePlayer>(createSinglePlayer());

export function SinglePlayerProvider({ children }: { children: ReactNode }) {
  const [player] = useState(createSinglePlayer);
  return <SinglePlayerContext value={player}>{children}</SinglePlayerContext>;
}

/** The one-playing-video policy `Media` claims through. */
export function useSinglePlayer(): SinglePlayer {
  return useContext(SinglePlayerContext);
}
